import axios from "../../axios";
import { ResponseModel } from "../../models/network/response_model";

import { GET_CUSTOMER_LIST, UPDATE_CUSTOMER_NOTE, GET_CUSTOMER_HISTORY } from "./customerTypes";
import { LIST_ALL, CUSTOMER_HISTORY_URL } from "./customerUrls";

export default {
  [GET_CUSTOMER_LIST]({ commit }, params) {
    axios.get(LIST_ALL, {
      params: params
    }).then((response) => {
      let responseModel = new ResponseModel(response);
      commit(GET_CUSTOMER_LIST, responseModel.result.data)
    });
  },
  [UPDATE_CUSTOMER_NOTE]({ commit }, item) {
    commit(UPDATE_CUSTOMER_NOTE, item);
  },
  [GET_CUSTOMER_HISTORY]({ commit }, id) {
    return new Promise((resolve, reject) => {
      if (id == null) {
        commit(GET_CUSTOMER_HISTORY);
      }
      axios.get(CUSTOMER_HISTORY_URL, { params: { id: id } })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          // console.log(responseModel.result.data);
          commit(GET_CUSTOMER_HISTORY, responseModel.result.data);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  }
}
